/**
 * Laravel `weather-bg-image` — hadise kodu → /weather-bg/{kod}.jpg
 * İkon adı örn. AB.svg → AB.jpg; yoksa A.jpg (açık hava).
 */

const AVAILABLE = new Set([
  'A',
  'AB',
  'CB',
  'DMN',
  'DY',
  'GKR',
  'GSY',
  'HKY',
  'HSY',
  'HY',
  'K',
  'KF',
  'KKR',
  'KKY',
  'MSY',
  'PB',
  'PUS',
  'R',
  'SCK',
  'SGK',
  'SIS',
  'SY',
  'Y',
  'YKY',
])

/** CDN’de JPG’si olmayan ikonlar → en yakın mevcut arka plan */
const FALLBACK: Record<string, string> = {
  KGY: 'Y',
  KSY: 'SY',
  KY: 'K',
}

export function weatherBgCodeFromIcon(icon?: string | null): string {
  const raw = (icon || 'A').replace(/\.svg$/i, '').trim().toUpperCase()
  if (AVAILABLE.has(raw)) return raw
  const mapped = FALLBACK[raw]
  if (mapped && AVAILABLE.has(mapped)) return mapped
  return 'A'
}

export function weatherBgUrl(icon?: string | null): string {
  return `/weather-bg/${weatherBgCodeFromIcon(icon)}.jpg`
}
